class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.isAnimating = false;
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-toggle-button]')) {
        e.preventDefault();
        this.toggle();
      }
    });

    this.setAttribute('data-state', 'collapsed');
  }

  toggle() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    const startHeight = this.offsetHeight;
    this.style.overflow = 'hidden';
    const targetExpanded = !this.isExpanded;
    this.setAttribute('data-state', targetExpanded ? 'expanded' : 'collapsed');
    const endHeight = this.scrollHeight;

    if (!targetExpanded) {
      this.setAttribute('data-state', 'expanded');
    }

    this.isExpanded = targetExpanded;

    const animation = this.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], {
      duration: 400,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    });

    animation.onfinish = () => {
      if (!this.isExpanded) {
        this.setAttribute('data-state', 'collapsed');
      }
      this.style.height = '';
      this.style.overflow = '';
      this.isAnimating = false;
      window.dispatchEvent(new Event('resize'));
    };

    animation.oncancel = animation.onfinish;
  }
}

if (!customElements.get('expandable-text')) {
  customElements.define('expandable-text', ExpandableText);
}
